document.documentElement.classList.add('js');
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.pp-reveal').forEach((el) => observer.observe(el));
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-pp-scroll-to-offer]');
  if (!trigger) return;
  const target = document.getElementById('patipello-offer-selector');
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    block: 'start'
  });
  const firstInteractive = target.parentElement?.querySelector('button, input, select, a[href]');
  if (firstInteractive) window.setTimeout(() => firstInteractive.focus({ preventScroll: true }), 450);
});
